import React, { useEffect, useState } from 'react';

const SnowAnimation = () => {
  const [snowflakes, setSnowflakes] = useState([]);

  useEffect(() => {
    const createSnowflake = () => ({
      id: Math.random(),
      left: Math.random() * 100,
      animationDuration: Math.random() * 10 + 5, // 5-15 seconds
      size: Math.random() * 10 + 5, // 5-15px
      delay: Math.random() * 5
    });

    const initialSnowflakes = Array.from({ length: 50 }, createSnowflake);
    setSnowflakes(initialSnowflakes);

    const interval = setInterval(() => {
      setSnowflakes(prev => [
        ...prev.slice(1), // Remove first snowflake
        createSnowflake() // Add new snowflake
      ]);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="snow-container">
      {snowflakes.map(snowflake => (
        <div
          key={snowflake.id}
          className="snowflake"
          style={{
            left: `${snowflake.left}%`,
            animationDuration: `${snowflake.animationDuration}s`,
            fontSize: `${snowflake.size}px`,
            animationDelay: `${snowflake.delay}s`
          }}
        >
          ❄
        </div>
      ))}
    </div>
  );
};

export default SnowAnimation;